import { RESET_PAGES_STATE_PARAMS, SET_CURRENT_PAGE, SET_PAGE_STATE_PARAMS } from '../actions/types'

const initialState = {
  page: null,
  params: [],
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_PAGE_STATE_PARAMS:
      const page = action.payload
      return { ...state, params: [...state.params.filter((p) => p.id !== page.id), page] }

    case SET_CURRENT_PAGE:
      return { ...state, page: action.payload }

    case RESET_PAGES_STATE_PARAMS:
      return { ...state, params: [] }
    default:
      return state
  }
}
